import { useEffect, useState } from 'react';
import { getCommerceActivity } from '../services/commerceService';

const normalizeActivities = (items = []) => {
    return items
        .filter(Boolean)
        .map((item) => {
            if (typeof item === 'string') {
                return { id: '', mccCode: '', businessName: item };
            }

            if (typeof item === 'object') {
                return {
                    id: item.id ?? '',
                    mccCode: item.mccCode ?? '',
                    businessName: item.businessName ?? '',
                };
            }

            return { id: '', mccCode: '', businessName: String(item) };
        })
        .filter((item) => item.businessName);
};

export function useCommerceActivity() {
    const [activities, setActivities] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        async function loadActivities() {
            try {
                const response = await getCommerceActivity();
                const payload = Array.isArray(response?.data) ? response.data : response;
                const normalized = normalizeActivities(Array.isArray(payload) ? payload : []);

                if (isMounted) {
                    setActivities(normalized);
                }
            } catch (error) {
                console.error('Error cargando actividades de comercio:', error);
                if (isMounted) {
                    setActivities([]);
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        }

        loadActivities();

        return () => {
            isMounted = false;
        };
    }, []);

    return { activities, loading };
}
